import { createApp } from 'vue'
import App from '@/App.vue'
import Vuex from 'vuex';

import alert from '@/store/alert';
import authentication from './authentication';
import users from './users';

const app = createApp(App)
app.use(Vuex);

const store = new Vuex.Store({
    modules: {
        alert,
        authentication,
        users
    }
});

export default store
